import React from 'react';
import Button from 'components/ui/Button';

const SignatureFieldsSidebar = ({
  fields,
  selectedSignerId,
  onSelect,
  onEdit,
  onRemove,
  disabled = false,
}) => {
  const confirmedFields = fields.filter((f) => f.isConfirmed);

  return (
    <div className="flex flex-col h-full min-h-0">
      <div className="px-4 py-3 border-b border-border flex-shrink-0">
        <h3 className="text-sm font-semibold text-foreground">Campos de assinatura</h3>
        <p className="text-xs text-muted-foreground mt-1">
          {confirmedFields.length === 0
            ? 'Nenhum campo adicionado.'
            : `${confirmedFields.length} campo(s) adicionado(s).`}
        </p>
      </div>

      <div className="flex-1 overflow-y-auto p-3 space-y-2 min-h-0">
        {confirmedFields.length === 0 ? (
          <div className="rounded-md border border-dashed border-border p-4 text-sm text-muted-foreground text-center">
            Clique em &quot;Adicionar campo assinatura&quot; para posicionar a primeira assinatura no PDF.
          </div>
        ) : (
          confirmedFields.map((field) => {
            const selected = selectedSignerId === field.signer_id;
            return (
              <div
                key={field.signer_id}
                className={`rounded-lg border p-3 transition-colors cursor-pointer ${
                  selected
                    ? 'border-primary bg-primary/5'
                    : 'border-border bg-card hover:border-primary/40'
                }`}
                onClick={() => onSelect(field.signer_id)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') onSelect(field.signer_id);
                }}
                role="button"
                tabIndex={0}
              >
                <p className="text-sm font-medium text-foreground truncate">
                  {field.full_name || 'Sem nome'}
                </p>
                <p className="text-xs text-muted-foreground truncate mt-0.5">
                  {field.email || '—'}
                </p>
                {field.telefone ? (
                  <p className="text-xs text-muted-foreground truncate mt-0.5">
                    {field.telefone}
                  </p>
                ) : null}
                <p className="text-xs text-muted-foreground mt-1">
                  Página {field.page_number}
                </p>
                <div className="flex gap-2 mt-2">
                  <Button
                    type="button"
                    variant="outline"
                    size="xs"
                    disabled={disabled}
                    onClick={(e) => {
                      e.stopPropagation();
                      onEdit(field.signer_id);
                    }}
                  >
                    Editar
                  </Button>
                  <Button
                    type="button"
                    variant="ghost"
                    size="xs"
                    className="text-destructive hover:text-destructive"
                    disabled={disabled}
                    onClick={(e) => {
                      e.stopPropagation();
                      onRemove(field.signer_id);
                    }}
                  >
                    Remover
                  </Button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default SignatureFieldsSidebar;
